
const state = {
  loader: {
    loading: false,
    componentKey: null      // null for loader at global/window level else for loader at components pass component key
  }
}

const getters = {
  getLoaderData () {
    return state.loader
  }
}

const actions = {
  setLoader ({ commit }, data) {
    commit('setLoader', data)
  }
}

const mutations = {
  setLoader (state, data) {
    state.loader = data
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/loader.js